import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import BaseApi from '@/core/HttpResources/BaseApi';
export default class AnnoucementAreasService {
  private client: BaseHttpClient;
  constructor(public controller: string = "AnnoucementAreas") {
    this.client = new BaseHttpClient(controller);
  }

  public async getJSON() {
    try {
      var result = await this.client.getAsync<any>("JSON");
      return result;
    } catch (error) {
      throw error;
    }
  }

  async GetAreasByAnnouncementId(announcementId: number) {
    var baseApi = new BaseApi(`Areas/Announcement/${announcementId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async GetFildAreasByAnnouncementId(announcementId: number) {
    var baseApi = new BaseApi(`Areas/FieldAreas/Announcement/${announcementId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async getFildAreasResearchLinesByAnnouncementId(announcementId: number) {
    var baseApi = new BaseApi(`Areas/FieldAreas/ResearchLines/Announcement/${announcementId}`);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}
